export default __webpack_public_path__ + "static/media/0x723b17718289a91af252d616de2c77944962d122.ca92de7d.webp";